import React from "react";
import "./CareerResources.css";
import DescriptionIcon from "@mui/icons-material/Description";
import EmojiObjectsIcon from "@mui/icons-material/EmojiObjects";
import Diversity2Icon from "@mui/icons-material/Diversity2";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import RecordVoiceOverIcon from "@mui/icons-material/RecordVoiceOver";

const CareerResources = () => {
  const blogs = [
    {
      icon: <DescriptionIcon className="resource-icon" />,
      title: "Top Resume Tips for Freshers",
      desc: "Your resume is your first impression — make it shine. Learn the right formats, keywords, and tricks to stand out and get shortlisted faster.",
      gradient: "linear-gradient(135deg, #00c6ff, #0072ff)",
    },
    {
      icon: <EmojiObjectsIcon className="resource-icon" />,
      title: "How to Crack Your First Interview",
      desc: "Master the art of interviews with practical strategies, real questions, and confidence-boosting tips from industry professionals.",
      gradient: "linear-gradient(135deg, #ff512f, #dd2476)",
    },
    {
      icon: <Diversity2Icon className="resource-icon" />,
      title: "Power of Networking in Job Search",
      desc: "Discover how to connect with HRs, recruiters, and professionals who can change your career. Networking opens doors that applications can’t.",
      gradient: "linear-gradient(135deg, #43e97b, #38f9d7)",
    },
    {
      icon: <LinkedInIcon className="resource-icon" />,
      title: "Mastering LinkedIn for Career Growth",
      desc: "Transform your LinkedIn into a personal brand. Optimize your profile, engage with the right audience, and attract recruiters naturally.",
      gradient: "linear-gradient(135deg, #f7971e, #ffd200)",
    },
    {
      icon: <RecordVoiceOverIcon className="resource-icon" />,
      title: "Developing Power Skills for Success",
      desc: "Enhance your communication, adaptability, and teamwork — because technical skills get you in, but soft skills make you unstoppable.",
      gradient: "linear-gradient(135deg, #a18cd1, #fbc2eb)",
    },
  ];

  return (
    <section className="career-resources">
      <div className="career-container">
        <h2 className="career-title">Career Resources & Insights</h2>
        <p className="career-subtitle">
          Learn. Apply. Grow — because every skill you build today shapes your
          career tomorrow.
        </p>

        <div className="resource-grid">
          {blogs.map((blog, index) => (
            <div
              key={index}
              className="resource-card"
              style={{ backgroundImage: blog.gradient }}
            >
              <div className="icon-circle">{blog.icon}</div>
              <h3 className="resource-heading">{blog.title}</h3>
              <p className="resource-desc">{blog.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CareerResources;
